// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/metar.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/metar/metar-decode.js';

mount([g0]);
